document.addEventListener('DOMContentLoaded', () => {
    const faqItems = document.querySelectorAll('.faq-item');
    const questions = document.querySelectorAll(".faq-question");
    let num, status;

    faqItems.forEach((item, index) => {
        const question = item.querySelector('.faq-question');
        question.addEventListener('click', () => {
            num = index;
            status = item.classList.contains("active");
            sessionStorage.setItem("num", num);
            sessionStorage.setItem("status", status);
        });
    });
})
document.addEventListener('click', () => {
    const items = document.querySelectorAll(".faq-item");
    if (sessionStorage.getItem("status") == "true") {
        console.log(sessionStorage.getItem("status"), "remove")
        items[sessionStorage.getItem("num")].classList.remove("active");
    }
    else {
        console.log(sessionStorage.getItem("status"), "add")
        items[sessionStorage.getItem("num")].classList.add("active");
    }
})